import { IApiResponse, IGlobalSignalrGroupResponse } from "@miplatform/types";
import { TASK_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const BASE_API = `${TASK_SERVICE}/global-signalr-groups`;

export const globalSignalrGroups = {
  getAll: async (): Promise<IApiResponse<IGlobalSignalrGroupResponse[]>> => {
    const options = await apiOptions({
      url: BASE_API,
      method: "get",
    });
    return apiRequest(options);
  },
};
